import { Box, Tooltip, Typography } from "@mui/material";
import { twMerge } from "tailwind-merge";
import InfoIcon from "@/assets/icons/settings/information.svg";

type THorizontal = "right" | "left";

type TVertical = "top" | "bottom";

type InfoSubTitleProps = {
	title: string;
	info?: string;
	placement?: THorizontal | TVertical;
	showInfo?: boolean;
	className?: string;
};

const InfoSubTitle = (props: InfoSubTitleProps) => {
	const { title, info = "", placement = "top", showInfo = false, className = "" } = props;
	const classes = twMerge("flex flex-row items-center", className);
	return (
		<Box className={classes}>
			<Typography className="!font-montserrat text-default !text-[16px] !p-0 !font-[500]">{title}</Typography>
			{showInfo && (
				<Tooltip title={info} placement={placement} arrow>
					<img src={InfoIcon} className="w-4 h-4 ml-2 mt-0.5" />
				</Tooltip>
			)}
		</Box>
	);
};

export default InfoSubTitle;
